import React, {memo, useCallback, useEffect, useMemo, useState} from "react"
import {useDispatch, useSelector} from "react-redux"
import {useHistory, useParams} from "react-router-dom"
import {Container} from "../../components/Container"
import {backButtonToggle} from "../../store/ui/actions"
import trashLogo from "../../assets/images/icons/trash.png"
import {useQuestion} from "../../hooks/question"
import {useRPC} from "../../hooks/rpc"
import {MessageList} from "../../store/control/state"
import {setMessageNotification} from "../../store/control/actions"
import "./index.scss"
import { useLocalization } from "../../hooks/localization"

function timeConverter(time: number) {
    const dateObject = new Date(time * 1000)
    return {
        year: dateObject.getFullYear().toString(),
        month:
            dateObject.getMonth() + 1 <= 9
                ? 0 + "" + (dateObject.getMonth() + 1).toString()
                : (dateObject.getMonth() + 1).toString(),
        day: dateObject.getDate() <= 9 ? 0 + "" + dateObject.getDate().toString() : dateObject.getDate().toString(),
        hour: dateObject.getHours() <= 9 ? 0 + "" + dateObject.getHours().toString() : dateObject.getHours().toString(),
        minute:
            dateObject.getMinutes() <= 9
                ? 0 + "" + dateObject.getMinutes().toString()
                : dateObject.getMinutes().toString(),
        week: dateObject.getDay().toString()
    }
}
export const MessageComponent = memo(function MessageComponent({
    messageId,
    messageTitle,
    messageContent,
    messageDate,
    messageStatus
}: MessageList) {
    const history = useHistory()
    const dispatch = useDispatch()
    const onClickGoMessage = useCallback(
        (id: string) => {
            dispatch(setMessageNotification(null))
            history.push(`/messaging/${id}`)
        },
        [history, dispatch]
    )
    const timeParse = timeConverter(Number(messageDate))
    const styles = useMemo(() => {
        return {
            backgroundColor: messageStatus === "0" ? "#0099c5" : "transparent"
        }
    }, [messageStatus])
    return (
        <div className="message-group-row" key={messageId} onClick={() => onClickGoMessage(messageId)}>
            <div className="messaging-read-status" style={styles}></div>
            <div className="message-row-left">
                <span>{messageTitle}</span>
                <span>{messageContent}</span>
            </div>
            <div className="message-row-right">
                <span>{timeParse.day + "/" + timeParse.month + "/" + timeParse.year}</span>
                <span>{timeParse.hour + ":" + timeParse.minute}</span>
            </div>
        </div>
    )
})

export const MessageDetailsComponent = memo(function MessageDetailsComponent({
    messageId,
    messageTitle,
    messageContent,
    messageType,
    userAnswer,
    apartment,
    messageDate,
    blok
}: MessageList) {
    //const question = useQuestion()
    const history = useHistory()
    const [rpc] = useRPC()
    const {t} = useLocalization()
    const [buttonDisabled, setButtonDisabled] = useState<boolean>(false)
    const timeParse = timeConverter(Number(messageDate))

    useEffect(() => {
        if (messageType === "2") {
            if (userAnswer === "1" || userAnswer === "2") {
                setButtonDisabled(true)
            }
        }
    }, [userAnswer, messageType])

    const onClickAction = useCallback(
        (id: string, status: string) => {
            switch (status) {
                case "1":
                    rpc.SetAnswerMessage({messageId: id, answer: "1", apartment: apartment, blok: blok})
                    break
                case "2":
                    rpc.SetAnswerMessage({messageId: id, answer: "2", apartment: apartment, blok: blok})
                    break
                case "3":
                    rpc.SetAnswerMessage({messageId: id, answer: "1", apartment: apartment, blok: blok})
                    break
                default:
                    break
            }
            history.push("/messaging")
        },
        [history, rpc, apartment, blok]
    )
    /*const onClickDelete = useCallback(
        (id: string) => {
            question("Seçili mesajı silmek istediğine emin misin", () => {
                console.log("Mesaj silindi! ", id)
            })
        },
        [question]
    )*/
    return (
        <div className="messaging-wrapper" key={messageId}>
            <div className="messaging-container">
                <div className="message-detail-container">
                    <div className="message-detail-top">
                        <div className="message-detail-top-left">
                            <span>{apartment + "/" + blok}</span>
                        </div>
                        <div className="message-detail-top-right">
                            <span>{timeParse.day + "/" + timeParse.month + "/" + timeParse.year}</span>
                            <span>{timeParse.hour + ":" + timeParse.minute}</span>
                        </div>
                    </div>
                    <div className="message-detail-content">
                        <p style={{color: "yellow", textAlign: "center"}}>{messageTitle}</p>
                        <p>{messageContent}</p>
                    </div>
                    <div className="message-detail-action">
                        {renderIf(messageType === "2")(
                            () => (
                                <>
                                    {renderIf(!buttonDisabled)(
                                        () => (
                                            <>
                                                <button
                                                    onClick={() => onClickAction(messageId, "1")}
                                                    style={{backgroundColor: "#17BE17"}}
                                                >
                                                    {t("messaging_screen.yes_button")}
                                                </button>
                                                <button
                                                    onClick={() => onClickAction(messageId, "2")}
                                                    style={{backgroundColor: "#D03137"}}
                                                >
                                                    {t("messaging_screen.no_button")}
                                                </button>
                                            </>
                                        ),
                                        () => (
                                            <span className="survey-result" onClick={() => history.push("/messaging")}>
                                                {t("messaging_screen.you_answered_survey")} (
                                                <span>
                                                    {userAnswer === "1"
                                                        ? t("messaging_screen.yes_lowercase")
                                                        : userAnswer === "2"
                                                        ? t("messaging_screen.no_lowercase")
                                                        : t("messaging_screen.no_lowercase")}
                                                </span>
                                                )
                                            </span>
                                        )
                                    )}
                                </>
                            ),
                            () => (
                                <button
                                    onClick={() => onClickAction(messageId, "3")}
                                    style={{backgroundColor: "#0099c5"}}
                                >
                                    {t("messaging_screen.i_read")}
                                </button>
                            )
                        )}
                        {/*<div className="message-trash">
                            <div className="message-trash-img" onClick={() => onClickDelete(messageId)}>
                                <img src={trashLogo} alt="" />
                            </div>
                            </div>*/}
                    </div>
                </div>
            </div>
        </div>
    )
})

export const MessagingScreen = memo(function MessagingScreen() {
    const messageList = useSelector(state => state.control.messageList)
    const dispatch = useDispatch()
    const {t} = useLocalization()
    //const question = useQuestion()
    const [rpc] = useRPC()

    useEffect(() => {
        rpc.GetMessageList()
    }, [rpc])

    const filteredMessageList = useMemo(() => {
        const announcementList = messageList?.announcement || []
        const questionsAnwsersList = messageList?.questionsAnwsers || []
        return [...announcementList, ...questionsAnwsersList]
    }, [messageList])

    const messageStatisticsList = useCallback(
        (type: string, status: string) =>
            filteredMessageList.filter(message => message.messageType === type && message.userAnswer === status).length,
        [filteredMessageList]
    )

    /*const onClickDeleteAll = useCallback(() => {
        question("Tüm mesajları silmek istediğine emin misin", () => {
            console.log("Mesajlar silindi!")
        })
    }, [question])*/

    useEffect(() => {
        dispatch(backButtonToggle({is_open: true, to: "/concierge"}))
    }, [dispatch])
    return (
        <Container className="full-screen">
            <div className="page-wrapper">
                <div className="messaging-wrapper">
                    <div className="messaging-container">
                        <div className="messages-group">
                            {renderIf(filteredMessageList.length > 0)(
                                () =>
                                    filteredMessageList
                                        .sort((a, b) => (a?.messageDate < b?.messageDate ? 1 : -1))
                                        .map(details => (
                                            <MessageComponent
                                                key={details?.messageId}
                                                messageId={details?.messageId}
                                                messageTitle={details?.messageTitle}
                                                messageContent={details?.messageContent}
                                                messageStatus={details?.messageStatus}
                                                messageDate={details?.messageDate}
                                                apartment={details?.apartment}
                                                userAnswer={details?.userAnswer}
                                                blok={details?.blok}
                                            />
                                        )),
                                () => (
                                    <div className="empty-message-text">
                                        <span>{t("messaging_screen.no_message_yet")}</span>
                                    </div>
                                )
                            )}
                        </div>
                        {/*<div className="messaging-button-container">
                            <button onClick={onClickDeleteAll}>TÜMÜNÜ SİL</button>
                            </div>*/}
                        {renderIf(filteredMessageList.length > 0)(() => (
                            <div className="message-statistics-container">
                                <div className="message-statistic-row">
                                    <div className="message-statistic">
                                        {t("messaging_screen.read")} <span>{messageStatisticsList("1", "1")}</span>
                                    </div>
                                    <div className="message-statistic">
                                        {t("messaging_screen.unread")} <span>{messageStatisticsList("1", "0")}</span>
                                    </div>
                                </div>
                                <div className="message-statistic-row">
                                    <div className="message-statistic">
                                        {t("messaging_screen.answered")} <span>{messageStatisticsList("2", "1") + messageStatisticsList("2", "2")}</span>
                                    </div>
                                    <div className="message-statistic">
                                        {t("messaging_screen.unanswered")} <span>{messageStatisticsList("2", "0")}</span>
                                    </div>
                                </div>
                                <div className="message-statistic-row">
                                    <div className="message-statistic">
                                        {t("messaging_screen.total")} <span>{filteredMessageList.length}</span>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </Container>
    )
})

export const MessageDetails = memo(function MessageDetails() {
    const dispatch = useDispatch()
    const messageList = useSelector(state => state.control.messageList)
    const params = useParams()
    const messageFilteredList = useMemo(() => {
        const announcementList = messageList?.announcement || []
        const questionsAnwsersList = messageList?.questionsAnwsers || []
        return [...announcementList, ...questionsAnwsersList]
    }, [messageList])
    useEffect(() => {
        dispatch(backButtonToggle({is_open: true, to: "/messaging"}))
    }, [dispatch, params])
    return (
        <Container className="full-screen">
            <div className="page-wrapper">
                {messageFilteredList.map(message =>
                    message.messageId === params["id"] ? (
                        <MessageDetailsComponent
                            key={message.messageId}
                            messageId={message.messageId}
                            messageContent={message.messageContent}
                            messageType={message.messageType}
                            messageTitle={message.messageTitle}
                            messageDate={message.messageDate}
                            userAnswer={message.userAnswer}
                            apartment={message.apartment}
                            blok={message.blok}
                        />
                    ) : null
                )}
            </div>
        </Container>
    )
})
